import { ReactNode } from 'react'
import Alert from '@mui/material/Alert'
import _ from 'lodash'
import { NoMarginTypography, TypographyBold } from '../styled-components'
import { FilterFieldProps } from '../types'
import { FolderFilterContextProvider } from './context'
import { FolderTree } from './folder-filter-tree'
import { useLazyFolderFilter } from './helpers'
import { t } from '@lingui/core/macro'

const FolderFilterContainer = ({ children }: { children: ReactNode | ReactNode[] }) => (
  <>
    <div style={{ marginTop: '8px' }} />
    <TypographyBold variant="h4">{t`Folder filter`}</TypographyBold>
    <NoMarginTypography variant="body2">
      {t`Select the folder you want to pull data from`}
    </NoMarginTypography>
    {children}
  </>
)

export const FolderFilter = ({
  filterField,
  onIntegrationChange,
  selectedIntegrationAccountId,
}: FilterFieldProps) => {
  const { folderConfig, filter, filterKey } = filterField

  if (!selectedIntegrationAccountId)
    return (
      <FolderFilterContainer>
        <Alert variant="filled" severity="warning">
          {t`The folder filter will be available after picking an integration account.`}
        </Alert>
      </FolderFilterContainer>
    )
  if (!folderConfig)
    return (
      <FolderFilterContainer>
        <Alert variant="filled" severity="error">
          We couldn't connect to the folder service API, please contact support.
        </Alert>
      </FolderFilterContainer>
    )

  const { treeState, reducers } = useLazyFolderFilter({
    filter,
    filterKey,
    folderConfig,
    onIntegrationChange,
    selectedIntegrationAccountId,
  })

  return (
    <FolderFilterContainer>
      <FolderFilterContextProvider
        treeState={treeState}
        reducers={reducers}
        selectedFolder={(filterField.filter as string) || '/'}
        onFolderSelected={val => {
          onIntegrationChange(val, filterField.filterKey)
        }}
      >
        <FolderTree />
      </FolderFilterContextProvider>
    </FolderFilterContainer>
  )
}
